import {
  Grid,
  TextField,
  Button,
  Box,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  pickers,
}) => {
  return (
    <Grid container spacing={3}>
      {/* Picker Autocomplete Filter */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Picker
        </InputLabel>
        <Autocomplete
          disablePortal
          options={pickers}
          getOptionLabel={(option) => option.picker_name}
          value={
            filterData.picker_id
              ? pickers.find((p) => p.picker_id === filterData.picker_id)
              : null
          }
          onChange={(_, newValue) => {
            handleChangeFilter("picker_id")(
              null,
              newValue ? newValue.picker_id : ""
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select Picker"
            />
          )}
        />
      </Grid>

      {/* Start Date Filter */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Start Date
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.start_date}
            onChange={(newValue) =>
              handleChangeFilter("start_date")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      {/* End Date Filter */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          End Date
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.end_date}
            onChange={(newValue) =>
              handleChangeFilter("end_date")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      {/* Action Buttons */}
      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            endIcon={<ArrowForward />}
            onClick={handleFilter}
            sx={{
              backgroundColor: "#7152F3",
              "&:hover": {
                backgroundColor: "#5a3fd1",
              },
            }}
          >
            Apply Filters
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
